import React from 'react';
import { connect } from 'react-redux';

import { login, reset } from '../../../../redux/auth/login/actions';
import { updateQueryString } from '../../../../redux/router/actions';
import * as routerSelectors from '../../../../redux/router/selectors';

import LoginModal from './LoginModal';

import { selectIsLoading, selectError, selectErrorMessage } from './selectors';

const LoginModalConnected = (props) => <LoginModal {...props} />;

const mapDispatchToProps = (state) => ({
  isLoading: selectIsLoading(state),
  error: selectError(state),
  errorMessage: selectErrorMessage(state),

  redirectTo: routerSelectors.selectRedirectTo(state),
});

const mapActionsToProps = {
  login,
  reset,
  updateQueryString,
};

export default connect(mapDispatchToProps, mapActionsToProps)(LoginModalConnected);
